<template>
  <div style="overflow:hidden" v-dragscroll.x>
    <div style="min-width:1340px">
      <v-row dense class="no-gutters d-flex">
        <div
          class="text-center action-link"
          v-for="(selectable_option) in option.options"
          @click="updated(selectable_option.value)"
          v-bind:key="selectable_option.name"
        >
          <v-hover class="ma-auto" v-slot:default="{ hover }">
            <v-card
              flat
              tile
              height="70"
              class="d-flex pa-0"
            >
              <v-card-text
                class="align-self-center"
                :class="barTextClass(selectable_option.value,hover)"
              >
                <v-icon size="35" :class="barTextClass(selectable_option.value,hover)">{{ selectable_option.icon }}</v-icon>
                <br>
                <span class="caption font-weight-bold">{{ selectable_option.text }}</span>
              </v-card-text>
            </v-card>
          </v-hover>
        </div>
        <v-dialog v-model="dialog" scrollable max-width="600">
          <leagues-modal @done="dialog = false;loading = false" />
        </v-dialog>
      </v-row>
    </div>
  </div>
</template>

<script>
import { SET_SELECTED_OPTION, GET_EVENTS } from "../../../store/actions.type";

import LeaguesModal from "./LeaguesModal";

export default {
  name: "SportBar",
  props: {
    option: Object,
  },
  data() {
    return {
      loading: false,
      dialog: false,
    };
  },
  components: {
    LeaguesModal,
  },
  computed: {
    selectedOptions() {
      return this.$store.getters.getCurrentSelectedOptions(this.option.key);
    },
  },
  methods: {
    updated(options) {
      this.loading = true;
      
      let key = this.option.key;

      if (options == 99) {
        this.dialog = true;
      } else {
        this.$gtag.event("api", {
          event_category: "options",
          event_label: "set_selected_option",
          value: options
        });
        this.$store.dispatch(SET_SELECTED_OPTION, { key, options }).then(() => {
          this.loading = false;
          this.$gtag.event("api", {
            event_category: "events",
            event_label: "get_events"
          });
          this.$store.dispatch(GET_EVENTS);
        });
      }
      
    },
    barTextClass(option, hover) {
      let text_class = "";

      text_class =
        this.selectedOptions == option ? "blue--text" : "black--text";

      if (hover) {
        //text_class = text_class + " subtitle-1";
      }

      return text_class;
    },
  },
};
</script>


<style scoped>
.action-link {
  cursor: pointer;
}
.scroll-row {
  overflow: hidden;
}
</style>